import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class EditTenantService {
  private tenantData: any;
  private isEdit: any;

  setData(data: any) {
    this.tenantData = data;
  }

  getData(): any {
    return this.tenantData;
  }

  getIsEdit(): any {
    return this.isEdit;
  }

  setIsEdit(data: any){
    this.isEdit = data;
  }
  clearData() {
    this.tenantData = null;
  }
}